import Vue from 'vue'
import Vuex from 'vuex'

import config from './modules/config'
import user from './modules/user'
import api from './modules/api'
import pageSize from './modules/pageSize'
import taxes from './modules/taxes'
import combo from './modules/combo'
import data from './modules/data'


import VuexPersistence from 'vuex-persist';
import localForage from 'localforage';


var localForageStore = localForage.createInstance({
    name: "servexWebStore",
    storeName: 'keyvaluepairs',
    description : 'Servex description store'
});

localForageStore.setDriver([localForageStore.INDEXEDDB, localForageStore.WEBSQL, localForageStore.LOCALSTORAGE ])

const vuexLocal = new VuexPersistence({
    key: 'servexWeb',
    storage: localForageStore,
    asyncStorage: true,
    modules: ['user','data','config']
});

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {  },
    mutations: {  },
    actions: {  },
    modules: {
        config,
        user,
        api,
        pageSize,
        taxes,
        combo,
        data,
    },
    plugins: [vuexLocal.plugin],
});

export default store;

